module.exports = __webpack_public_path__ + "static/media/shops_hover.795e33e7.svg";